import { LocalStore } from '@/models/LocalStore';

import { AlertsStore } from './AlertsStore';
import { QueryStore } from './QueryStore';
import { StopwatchStore } from './StopwatchStore';
import { uiStore } from './UiStore/UiStore';
import { UserStore } from './UserStore';
import { IRootStore } from './types';

export class RootStore extends LocalStore implements IRootStore {
  readonly alertsStore = new AlertsStore();
  userStore = new UserStore(this.alertsStore);
  queryStore = new QueryStore();
  readonly uiStore = uiStore;
  readonly stopwatchStore = new StopwatchStore({ alertsStore: this.alertsStore });
}
